import {FileRecord} from '@packages/systems/core/records/FileRecord';

const targetResult = (e) => e.target.result;

export const createFileReader =
  (window) =>
  ({blob, asType, mapResult}) => {
    const readerPromise = new Promise((resolve, reject) => {
      const reader = new window.FileReader();
      reader.onload = resolve;
      reader.onerror = reject;
      reader[asType === 'text' ? 'readAsText' : 'readAsArrayBuffer'](blob);
    }).then(targetResult);

    if (mapResult) {
      return readerPromise.then(mapResult);
    }

    return readerPromise;
  };

export const reifyFileBlob = ({
  window,
  date,
  id,
  blob,
  siteId,
  databaseId,
  isFromWellKnownFolder = false,
}) =>
  new FileRecord({
    _id: id,
    [siteId ? 'siteId' : 'databaseId']: siteId || databaseId,
    fileName: blob.name,
    origFileName: blob.name,
    mimeType: blob.type,
    externalUrl: blob.externalUrl,
    blob,
    blobUrl: window.URL.createObjectURL(blob),
    fileSize: blob.size,
    createdOn: date,
    uploadProgress: 0,
    isFromWellKnownFolder,
  });

export const loadImage = (window) => (url) =>
  new Promise((resolve, reject) => {
    const image = new window.Image();
    if (url) {
      image.onload = () => resolve(image);
      image.onerror = () => reject(image);
      image.src = url;
    } else {
      // If no URL was provided, reject immediately instead of loading and
      // waiting for a 404 response:
      reject(image);
    }
  });

export const scaleImage =
  (window) =>
  ({url, width, height}) =>
    loadImage(window)(url).then((image) => {
      const canvas = window.document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);
      return canvas.toDataURL('image/png');
    });
